export class OrderMismatchedItemPriceError extends Error {
    constructor() {
        super('MISMATCHED_ITEM_PRICE');
    }
}
